import { useQuery } from '@tanstack/react-query'
import ChallengeBucket from '../../model/ChallengeBucket'
import { dataSource } from '../../service/domain/_service.config'

export const CHALLENGE_BUCKETS_QUERY_KEY = (challengeID: string) =>
  ['challengeBuckets', challengeID] as const

export function useChallengeBuckets(challengeID: string) {
  return useQuery<ChallengeBucket[]>({
    queryKey: CHALLENGE_BUCKETS_QUERY_KEY(challengeID),
    queryFn: () => dataSource.getChallengeBuckets(challengeID),
    enabled: !!challengeID,
  })
}
